import { useNavigate } from "react-router-dom";
import { ArrowLeft, Edit3 } from "lucide-react";
import CoreProposal from "@/pages/CoreProposal";

export default function AdminEditCore() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen">
      <div className="sticky top-0 z-50 px-4 md:px-8 py-3 flex items-center justify-between gap-4 shadow-sm" style={{ background: "#0F1E2E", color: "#FDFBF5" }}>
        <div className="flex items-center gap-4">
          <button onClick={() => nav("/admin")} data-testid="edit-back"
                  className="inline-flex items-center gap-2 mono text-[10px] uppercase tracking-[0.18em] opacity-80 hover:opacity-100 transition">
            <ArrowLeft className="h-3.5 w-3.5" /> Admin
          </button>
          <div className="inline-flex items-center gap-2 mono text-[10px] uppercase tracking-[0.18em]" style={{ color: "#F5B400" }}>
            <Edit3 className="h-3.5 w-3.5" /> Editing · Core deck (all standard prospects)
          </div>
          <div className="hidden md:block text-xs opacity-65 mono">Click any highlighted block to edit · Enter = save, Esc = cancel · Open any prospect link to see it live</div>
        </div>
      </div>
      <CoreProposal editMode={true} />
    </div>
  );
}
